"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
/**
 * Canonical error codes (TZ §43).
 *
 * Clients switch on these codes, so they are part of the public API contract:
 * rename one and every app breaks. Add new codes, never repurpose old ones.
 */
exports.ErrorCode = {
    // --- Generic ---
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    RATE_LIMITED: 'RATE_LIMITED',
    BAD_REQUEST: 'BAD_REQUEST',
    // --- Auth ---
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    TOKEN_INVALID: 'TOKEN_INVALID',
    REFRESH_TOKEN_REVOKED: 'REFRESH_TOKEN_REVOKED',
    USER_INACTIVE: 'USER_INACTIVE',
    PERMISSION_DENIED: 'PERMISSION_DENIED',
    TELEGRAM_INIT_DATA_INVALID: 'TELEGRAM_INIT_DATA_INVALID',
    // --- Tenant / subscription ---
    TENANT_NOT_FOUND: 'TENANT_NOT_FOUND',
    TENANT_BLOCKED: 'TENANT_BLOCKED',
    /**
     * A public request never said which restaurant it meant — no
     * `X-Tenant-Slug`, and the Host is not a restaurant's own domain. The
     * storefront shows a "pick a restaurant" page for this; it is the expected
     * answer at the platform's bare domain, not a fault.
     */
    TENANT_NOT_SPECIFIED: 'TENANT_NOT_SPECIFIED',
    /**
     * A tenant-scoped query ran with no tenant in context on an AUTHENTICATED
     * request — a server bug, not something a client can cause. Public requests
     * get TENANT_NOT_SPECIFIED instead.
     */
    TENANT_SCOPE_MISSING: 'TENANT_SCOPE_MISSING',
    CROSS_TENANT_ACCESS: 'CROSS_TENANT_ACCESS',
    SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED',
    SUBSCRIPTION_LIMIT_REACHED: 'SUBSCRIPTION_LIMIT_REACHED',
    // --- Catalog ---
    CATEGORY_NOT_FOUND: 'CATEGORY_NOT_FOUND',
    PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
    PRODUCT_UNAVAILABLE: 'PRODUCT_UNAVAILABLE',
    MODIFIER_NOT_FOUND: 'MODIFIER_NOT_FOUND',
    MODIFIER_SELECTION_INVALID: 'MODIFIER_SELECTION_INVALID',
    // --- Branch ---
    BRANCH_NOT_FOUND: 'BRANCH_NOT_FOUND',
    BRANCH_CLOSED: 'BRANCH_CLOSED',
    OUTSIDE_DELIVERY_RADIUS: 'OUTSIDE_DELIVERY_RADIUS',
    MIN_ORDER_NOT_REACHED: 'MIN_ORDER_NOT_REACHED',
    // --- Orders ---
    ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',
    ORDER_EMPTY: 'ORDER_EMPTY',
    INVALID_STATUS_TRANSITION: 'INVALID_STATUS_TRANSITION',
    ORDER_ALREADY_CANCELLED: 'ORDER_ALREADY_CANCELLED',
    DUPLICATE_ORDER: 'DUPLICATE_ORDER',
    // --- Payments ---
    PAYMENT_NOT_FOUND: 'PAYMENT_NOT_FOUND',
    PAYMENT_AMOUNT_MISMATCH: 'PAYMENT_AMOUNT_MISMATCH',
    PAYMENT_ALREADY_PROCESSED: 'PAYMENT_ALREADY_PROCESSED',
    PAYMENT_PROVIDER_ERROR: 'PAYMENT_PROVIDER_ERROR',
    WEBHOOK_SIGNATURE_INVALID: 'WEBHOOK_SIGNATURE_INVALID',
    REFUND_EXCEEDS_PAID: 'REFUND_EXCEEDS_PAID',
    // --- Cash register ---
    SHIFT_ALREADY_OPEN: 'SHIFT_ALREADY_OPEN',
    SHIFT_NOT_OPEN: 'SHIFT_NOT_OPEN',
    CASH_REGISTER_NOT_FOUND: 'CASH_REGISTER_NOT_FOUND',
    // --- Couriers ---
    COURIER_NOT_FOUND: 'COURIER_NOT_FOUND',
    COURIER_UNAVAILABLE: 'COURIER_UNAVAILABLE',
    COURIER_NOT_ASSIGNED: 'COURIER_NOT_ASSIGNED',
    INSUFFICIENT_WALLET_BALANCE: 'INSUFFICIENT_WALLET_BALANCE',
    // --- Promotions ---
    PROMO_CODE_NOT_FOUND: 'PROMO_CODE_NOT_FOUND',
    PROMO_CODE_EXPIRED: 'PROMO_CODE_EXPIRED',
    PROMO_CODE_LIMIT_REACHED: 'PROMO_CODE_LIMIT_REACHED',
    PROMO_CODE_NOT_APPLICABLE: 'PROMO_CODE_NOT_APPLICABLE',
    // --- Storefront customers ---
    /**
     * Checkout needs a name, surname and phone the customer has not given yet.
     * `details.missing` lists which; the Mini App asks for exactly those and
     * then resubmits the same checkout.
     */
    PROFILE_INCOMPLETE: 'PROFILE_INCOMPLETE',
    /** The chosen payment option is not enabled for this restaurant right now. */
    PAYMENT_METHOD_UNAVAILABLE: 'PAYMENT_METHOD_UNAVAILABLE',
    ADDRESS_NOT_FOUND: 'ADDRESS_NOT_FOUND',
    /** A customer-only endpoint was called without a customer session. */
    CUSTOMER_SESSION_REQUIRED: 'CUSTOMER_SESSION_REQUIRED',
    /** A marketing send inside the restaurant's cooling-off window. */
    CAMPAIGN_RATE_LIMITED: 'CAMPAIGN_RATE_LIMITED',
    // --- Storage / integrations ---
    FILE_TOO_LARGE: 'FILE_TOO_LARGE',
    UNSUPPORTED_FILE_TYPE: 'UNSUPPORTED_FILE_TYPE',
    STORAGE_ERROR: 'STORAGE_ERROR',
    TELEGRAM_SEND_FAILED: 'TELEGRAM_SEND_FAILED',
};
//# sourceMappingURL=error-codes.js.map